var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3000_567)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3000_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2773 11.9885C9.43097 13.8369 6.65268 14.3905 4.23888 13.3909C1.82508 12.3913 0.251586 10.0356 0.25267 7.42301C0.25267 5.11537 1.48378 2.98303 3.48225 1.82921C5.48073 0.675391 7.94295 0.675391 9.94142 1.82921C11.9399 2.98303 13.171 5.11537 13.171 7.42301C13.1749 9.13667 12.493 10.7806 11.2773 11.9885ZM3.13802 11.1539C5.16898 13.1416 8.42417 13.1154 10.4229 11.0952C12.4215 9.0749 12.4127 5.81961 10.4032 3.81014C8.39376 1.80067 5.13847 1.79192 3.11818 3.79051C1.09799 5.78921 1.07174 9.0444 3.05949 11.0754L3.13802 11.1539ZM7.35511 10.4321L6.06811 10.4316L6.06811 8.06674L3.70322 8.06674V6.77929H6.06811V4.4144H7.35556L7.35556 6.77929L9.72045 6.77929L9.72091 8.06628L7.35556 8.06674L7.35556 10.4316L7.35511 10.4321Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3000_567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3000_567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.2f0f8526ccf373e2723cf280d845d1f4.svg";
export { ForwardRef as ReactComponent };